import { SET_CONFIG_API_STATE, RECEIVE_CONFIG, LOGOUT } from '../constants/ActionTypes';

const initial = { groups: [], envManaged: [], mcp: null, apiState: "init" };

const config = (state = initial, action) => {
  switch (action.type) {
    case SET_CONFIG_API_STATE:
      return { ...state, apiState: action.apiState };
    case RECEIVE_CONFIG:
      return {
        ...state,
        groups: action.config.groups || [],
        envManaged: action.config.envManaged || [],
        mcp: action.config.mcp || null,
        apiState: "ready"
      };
    case LOGOUT:
      return initial;
    default:
      return state;
  }
};

export default config;
